import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RdsModule } from '@rabobank/rds-angular';
import { Toast, ToastService } from '../../services/toast.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-toast-outlet',
  standalone: true,
  imports: [CommonModule, RdsModule],
  template: `
    <div class="toast-container" *ngIf="toasts$ | async as toasts">
      <rds-toast *ngFor="let t of toasts" [type]="t.type" class="toast-item">
        <span>{{ t.message }}</span>
      </rds-toast>
    </div>
  `,
  styles: [`
    /* Center bottom placement for global toasts */
    .toast-container {
      position: fixed;
      bottom: 1.5rem;
      left: 50%;
      transform: translateX(-50%);
      z-index: 2500;
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
      pointer-events: none;
      align-items: center;
      max-width: calc(100% - 2rem);
    }
    .toast-item { pointer-events: auto; min-width: 240px; }
    @media (max-width: 420px) {
      .toast-item { min-width: auto; width: calc(100% - 2rem); }
      .toast-container { bottom: 1rem; }
    }
  `]
})
export class ToastOutletComponent {
  public toasts$: Observable<Toast[]>;
  constructor(private toastService: ToastService) {
    this.toasts$ = this.toastService.toasts$;
  }

  public dismiss(id: number): void {
    this.toastService.dismiss(id);
  }
}
